import { useContext, useEffect, useState } from "react";
// import apiPaths from "../../utils/api-paths";
import { API } from "aws-amplify";
import context from "../../Context/Context";

const DateFormatter = ({ epochDate }) => {
  const { userData } = useContext(context);
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    if (!epochDate) {
      setFormattedDate("Invalid Date");
      return;
    }

    try {
      const timestamp = typeof epochDate === 'string' && /^\d+$/.test(epochDate)
        ? parseInt(epochDate)
        : epochDate;
      const date = new Date(timestamp);
      // Always use US format (mm/dd/yyyy) regardless of user location
      setFormattedDate(
        date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })
      );
    } catch (error) {
      console.error("Error formatting date:", error);
      setFormattedDate("Invalid Date");
    }
  }, [epochDate]);

  return <>{formattedDate}</>;
};

export default DateFormatter;
